import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { GuestSurvey, SurveyOutreachFilters } from './guest-survey.model';
import { PaginationState } from '../models.common';

export interface GuestSurveyState extends EntityState<GuestSurvey>, ActiveState<GuestSurvey['id']> {
  ui: SurveyOutreachFilters;
  pagination: PaginationState;
}

@StoreConfig({ name: 'guest-survey', resettable: true })
export class GuestSurveyStore extends EntityStore<GuestSurveyState> {
  constructor() {
    super({
      ui: {},
      pagination: {
        isDone: true,
        continuationToken: undefined,
      },
    });
  }
}

export const guestSurveyStore = new GuestSurveyStore();
